module.exports = __webpack_public_path__ + "static/media/brrands_PENTAIR.cab0c851.svg";